// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JUIy","location":"Header_location__8LhI3"};